<template>
  <div id="member-info">
    <div class="wrapper">
      <div class="container">
        <div class="block">
          <div class="block-title">
            <span>成员信息</span>
          </div>
          <div class="normal">
            <label class="must">姓名</label>
            <input v-model="memberInfo.real_name" type="text" placeholder="为确保获取投保信息请输入真实姓名" />
          </div>
          <div class="big relationship">
            <p>
              <label class="must">与您的关系</label>
            </p>
            <ul>
              <li
                :class="memberInfo.role == index + 1 ? 'active' : ''"
                v-for="(item, index) in role_label"
                :key="index"
                @click="chooseRelationship(index + 1)"
              >{{item}}</li>
              <input
                v-model="memberInfo.role_label"
                v-if="memberInfo.role == 9"
                type="text"
                placeholder="请填写具体关系"
              />
            </ul>
          </div>
        </div>

        <div class="block">
          <div class="block-title">
            <span>其他信息</span>
            <span class="select">（选填）</span>
          </div>
          <div class="normal">
            <label>性别</label>
            <input @click="showPopup('sex')" type="text" v-model="memberInfo.sexname"  readonly/>

            <!-- <input type="text" v-model="memberInfo.sex" placeholder="请输入性别" /> -->
          </div>
          <div class="normal">
            <label>身份证</label>
            <input type="text" v-model="memberInfo.id_number" placeholder="请输入有效的证件号" />
          </div>
          <div class="normal">
            <label>出生日期</label>
            <input @click="showPopup('birthday')" type="text" v-model="memberInfo.birthday" placeholder="请选择 >" readonly/>
          </div>
          <div class="normal">
            <label>手机号码</label>
            <input type="number" v-model="memberInfo.telephone" placeholder="请输入11位数的手机号码" />
          </div>
          <div class="normal">
            <label>职业</label>
             <input type="text" v-model="memberInfo.occupation" placeholder="请输入职业名称" />
            <!-- <input @click="showPopup('occupation')" type="text" v-model="occupationInput"  placeholder="请选择 >" readonly/> -->
          </div>
          <div class="big situation">
            <p>
              <label>保障情况</label>
            </p>
            <div class="content">
              <span v-for="(item, index) in protectionChoose" :key="index">
                {{protection[item]}}
                <img
                  src="@/assets/images/memberInfo/delete.png"
                  @click="deleteProtection(index,item)"
                />
              </span>
              <i class="add" @click="showPopup('protection')">
                <img src="@/assets/images/memberInfo/add.png" />
                添加
              </i>
            </div>
          </div>
          <div class="big situation">
            <p>
              <label>疾病情况</label>
            </p>
            <div class="content">
              <span v-for="(item, index) in diseaseChoose" :key="index">
                {{disease[item]}}
                <img
                  src="@/assets/images/memberInfo/delete.png"
                  @click="deleteDisease(index,item)"
                />
              </span>
              <i class="add" @click="showPopup('disease')">
                <img src="@/assets/images/memberInfo/add.png" />
                添加
              </i>
            </div>
          </div>
        </div>
        
        <button class="savebtn" @click="verify">保存</button>
      </div>
    </div>
    
    <transition-group  name="van-slide-up">
      <div v-show="popupControl.disease" class="diseaseul" :key="1">
        <div>
          <span class="van-picker__cancel" @click="closePopup('disease')">取消</span>
          <span class="van-ellipsis van-picker__title">添加疾病情况</span>
          <span class="van-picker__confirm" @click="onDiseaseConfirm">确定</span>
        </div>
        <ul >
          <li :attr="items[item]" :attr1="item" @click="choseitem(item)" v-for="(i,item) in disease" :key="item" :class="items[item] == item ? 'active':''">{{i}}</li>
        </ul>
      </div>

      <div v-show="popupControl.protection" class="diseaseul" :key="2">
        <div>
          <span class="van-picker__cancel" @click="closePopup('protection')">取消</span>
          <span class="van-ellipsis van-picker__title">添加保障情况</span>
          <span class="van-picker__confirm" @click="onProtectionConfirm">确定</span>
        </div>
        <ul >
          <li :attr="item2[item]" :attr1="item" @click="choseite2(item)" v-for="(i,item) in protection" :key="item" :class="item2[item] == item ? 'active':''">{{i}}</li>
        </ul>
      </div>
    </transition-group>

    <van-popup position="bottom" v-model="popupControl.birthday">
      <van-datetime-picker
        v-model="datetimePicker.currentDate"
        type="date"
        :min-date="datetimePicker.minDate"
        :max-date="datetimePicker.maxDate"
        @cancel="closePopup('birthday')"
        @confirm="onBirthdayConfirm"
      />
    </van-popup>
   
    <van-popup position="bottom" v-model="popupControl.sex">
      <van-picker
        show-toolbar
        title="性别"
        :columns="sexarr"
        @cancel="closePopup('sex')"
        @confirm="onsexConfirm"
      />
    </van-popup>

    <!-- <van-popup position="bottom" v-model="popupControl.occupation">
      <van-picker
        show-toolbar
        title="职业"
        :columns="occupation"
        @cancel="closePopup('occupation')"
        @confirm="onOccupationConfirm"
      />
    </van-popup> -->

    <!-- <van-popup position="bottom" v-model="popupControl.protection">
      <van-picker
        show-toolbar
        title="添加保障情况"
        :columns="protection"
        @cancel="closePopup('protection')"
        @confirm="onProtectionConfirm"
      />
    </van-popup> -->
    <!-- <van-popup position="bottom" v-model="popupControl.disease">
      <van-picker
        show-toolbar
        title="添加疾病情况"
        :columns="disease"
        @cancel="closePopup('disease')"
        @confirm="onDiseaseConfirm"
      />
    </van-popup> -->


  </div>
</template>

<script>
// 填写成员信息
export default {
  name: 'memberInfo',
  data() {
    return {
      items:[],
      item2:[],
      from: '',
      memberId: '',
      // 显示的数据
      role_label: ['本人','配偶','儿子','女儿','父亲','母亲','配偶父亲','配偶母亲','其他'],
      sexarr:['男','女'],
      occupation: ['室内轻体力（行政、管理人员）', '室内中体力（程序员）', '户外简单工作（导游、司机）', '户外复杂工作（工程师、建筑工人）', '室内制造业（装修、流水线工人）', '家庭主妇', '其他'],
      disease:['无','住院','手术','门诊','体检'],
      // disease: ['无', '其他', 'BMI偏高', 'BMI偏低', '高血压', '肺气肿', '慢性支气管炎', '肺结核', '哮喘', '肺炎', '肺纤维化', '肺结节',
      //   '乙肝-大三阳', '乙肝-小三阳', '乙肝病毒携带', '甲状腺结节', '甲状腺功能亢进', '甲状腺功能减退', '乳腺增生', '乳腺结节',
      //   '胆囊息肉', '肾囊肿', '肾结石', '肾炎', '子宫肌瘤', '卵巢囊肿', '宫颈炎', '孕期28周内', '孕期28周后', '轻度脂肪肝',
      //   '中度脂肪肝', '重度脂肪肝', '结节/息肉/囊肿等赘生物', '近两年有住院史或体检异常', '为2周岁以下婴儿（是否早产）',
      //   '心脑血管疾病', '良性肿瘤', '精神类疾病（抑郁症/焦虑症/焦躁症等）', '吸毒史/艾滋病患者', '甲型肝炎/丙型肝炎',
      //   '高血脂', '高血糖'],
      protection: ['无', '其他', '社保（包含新农合）', '重疾险', '寿险', '医疗险', '意外险', '防癌险', '年金险', '理财险'],
      // occupationInput:'',

      // 需要提交的信息
      memberInfo: {
        real_name: '',
        role: 1,
        role_label:'',
        id_number: '',
        birthday: '',
        telephone: '',
        occupation: '',
        protection: '',
        new_disease: '',
        gender:0,
        sexname:''
      },
      protectionChoose: [],
      diseaseChoose: [],

      // popup
      popupControl: {
        birthday: false,
        // occupation: false,
        protection: false,
        disease: false,
        sex:false,
      },
      datetimePicker: {
        minDate: new Date(1920, 0, 1),
        maxDate: new Date(2025, 12, 31),
        currentDate: new Date(),
      }
    }
  },
  methods: {
    // 确定保障
    onProtectionConfirm(){
      this.protectionChoose = [];
      for(var i in this.item2){
        if(this.item2[i] || this.item2[i] === 0){
          this.protectionChoose.push(this.item2[i])
        }
      }

      console.log(this.protectionChoose,'this.protectionChoose')
      this.closePopup('protection')
    },
    // 确定疾病
    onDiseaseConfirm(){
       this.diseaseChoose = [];
      for(var i in this.items){
        if(this.items[i] || this.items[i] === 0){
          this.diseaseChoose.push(this.items[i])
        }
      }
      this.closePopup('disease')
    },
    // 疾病多选
    choseitem(item){
      // 点击取消
      if(item == 0){
        if(this.items[0] == 0 && this.items.length == 1){
            this.items = []
        }else if(this.items.length){
          this.$dialog.confirm({
            title: '提示',
            message: '选择无后其他疾病将无法选择，是否确定选择？',
          }).then(() => {
            this.items = [];
            this.$set(this.items,0,0)
          }).catch(() => {
            
          });
        }else{
          this.items = [];
          this.$set(this.items,0,0)
        }
      }else if(this.items.indexOf(item) == -1){
        if(this.items.indexOf(0) != -1 || this.items.indexOf('0') != -1){
          this.items = []
          this.$set(this.items,item,item)
          // this.$toast('您已添加过无，不能再添加其余选项了哦')
        }else{
          this.$set(this.items,item,item)
        }
      }else{
        this.$set(this.items,item,'')
      }
    },
    // 保障多选
    choseite2(item){
      // 点击取消
      if(item == 0){
        if(this.item2[0] == 0 && this.item2.length == 1){
            this.item2 = []
        }else if(this.item2.length){
          this.$dialog.confirm({
            title: '提示',
            message: '选择无后其他保障将无法选择，是否确定选择？',
          }).then(() => {
            this.item2 = [];
            this.$set(this.item2,0,0)
          }).catch(() => {
            
          });
        }else{
          this.item2 = [];
          this.$set(this.item2,0,0)
        }
      }else if(this.item2.indexOf(item) == -1){
        if(this.item2.indexOf(0) != -1 || this.item2.indexOf('0') != -1){
          this.item2 = []
          this.$set(this.item2,item,item)
          // this.$toast('您已添加过无，不能再添加其余选项了哦')
        }else{
          this.$set(this.item2,item,item)
        }
      }else{
        this.$set(this.item2,item,'')
      }
    },
    chooseRelationship(i){
      this.memberInfo.role = i
    },
    deleteProtection(i,item){
      this.protectionChoose.splice(i,1)
      this.$set(this.item2,item,'')
    },
    deleteDisease(i,item){
      this.diseaseChoose.splice(i,1)
      this.$set(this.items,item,'')
    },
    // popup开关
    showPopup(type){
      this.popupControl[type] = true
    },
    closePopup(type){
      this.popupControl[type] = false
    },
    // popup确认
    onBirthdayConfirm(value){
      let date = this.Global.formatDate(value)
      this.memberInfo.birthday = date
      this.closePopup('birthday')
    },
    onOccupationConfirm(value, index){
      this.occupationInput = value
      this.memberInfo.occupation = index + 1
      this.closePopup('occupation')
    },
    onsexConfirm(value,index){
      this.memberInfo.gender = index+1;
      this.memberInfo.sexname = value;
      this.closePopup('sex')
    },
    // 身份证号验证
    isCid(value) {
      let SystemDate = new Date();
      let year = SystemDate.getFullYear();
      let month = SystemDate.getMonth() + 1;
      let day = SystemDate.getDate();
      let yyyy; // 年
      let mm; // 月
      let dd; // 日

      let id = value;
      let idLength = id.length;

      if (idLength == 0) {
        console.log("请输入身份证号码!");
        return false;
      }

      if (idLength != 15 && idLength != 18) {
        console.log("身份证号长度应为15位或18位！");
        return false;
      }

      if (idLength == 15) {
        for (let i = 0; i < idLength; i++) {
          if (isNaN(value.charAt(i))) {
            console.log("15位身份证号中不能有字符！");
            return false;
          }
        }

        yyyy = "19" + id.substring(6, 8);
        mm = id.substring(8, 10);
        dd = id.substring(10, 12);

        if (mm > 12 || mm <= 0) {
            console.log("身份证号月份非法！");
            return false;
        }

        if (dd > 31 || dd <= 0) {
            console.log("身份证号日期非法！");
            return false;
        }

        if ((mm == 4 || mm == 6 || mm == 9 || mm == 11) && dd > 30) // 4,6,9,11月份日期不能超过30
        {
          console.log("身份证号日期非法！");
          return false;
        }

        if (mm == 2) // 判断2月份
        {
          if (this.LeapYear(yyyy)) {
            if (dd > 29) {
              console.log("身份证号日期非法！");
              return false;
            }
          } else {
            if (dd > 28) {
              console.log("身份证号日期非法！");
              return false;
            }
          }
        }
      } else if (idLength == 18) {

        for (let i = 0; i < idLength - 1; i++) {
          // console.log(i+"="+value.charAt(i));
          if (isNaN(value.charAt(i))) {
            console.log("身份证号中前17位中不能有字符！");
            return false;
          }
        }

        if (isNaN(value.charAt(17)) && value.charAt(17) != "X" && value.charAt(17) != "x") {
          console.log("身份证校验错误，请认真检查！");
          return false;
        }
        if (value.indexOf("X") > 0 && value.indexOf("X") != 17 || value.indexOf("x") > 0 && value.indexOf("x") != 17) {
          console.log("身份证中\"X\"输入位置不正确！");
          return false;
        }

        yyyy = id.substring(6, 10);
        if (yyyy > year || yyyy < 1900) {
          console.log("身份证号年度非法！");
          return false;
        }

        mm = id.substring(10, 12);
        if (mm > 12 || mm <= 0) {
          console.log("身份证号月份非法！");
          return false;
        }
        if (yyyy == year && mm > month) {
          console.log("身份证号月份非法！");
          return false;
        }

        dd = id.substring(12, 14);
        if (dd > 31 || dd <= 0) {
          console.log("身份证号日期非法！");
          return false;
        }

        if ((mm == 4 || mm == 6 || mm == 9 || mm == 11) && dd > 30) // 4,6,9,11月份日期不能超过30
        {
          console.log("身份证号日期非法！");
          return false;
        }

        if (mm == 2) // 判断2月份
        {
          if (this.LeapYear(yyyy)) {
            if (dd > 29) {
              console.log("身份证号日期非法！");
              return false;
            }
          } else {
            if (dd > 28) {
              console.log("身份证号日期非法！");
              return false;
            }
          }
        }
        if (yyyy == year && mm == month && dd > day) {
          console.log("身份证号日期非法！");
          return false;
        }

        if (id.charAt(17) == "x" || id.charAt(17) == "X") {
          if ("X" != this.GetVerifyBit(id)) {
            console.log("身份证校验错误，请认真检查！");
            return false;
          }
        } else {
          if (id.charAt(17) != this.GetVerifyBit(id)) {
            console.log("身份证校验错误，请认真检查！");
            return false;
          }
        }
      }
      return true;
    },
    GetVerifyBit(id) {
      let result = "";
      let nNum = eval(id.charAt(0) * 7 + id.charAt(1) * 9 + id.charAt(2) * 10 + id.charAt(3) * 5 + id.charAt(4) * 8 + id.charAt(5) * 4 + id.charAt(6) * 2 + id.charAt(7) * 1 + id.charAt(8) * 6 + id.charAt(9) * 3 + id.charAt(10) * 7 + id.charAt(11) * 9 + id.charAt(12) * 10 + id.charAt(13) * 5 + id.charAt(14) * 8 + id.charAt(15) * 4 + id.charAt(16) * 2);
      nNum = nNum % 11;
      switch (nNum) {
        case 0:
          result = "1";
          break;
        case 1:
          result = "0";
          break;
        case 2:
          result = "X";
          break;
        case 3:
          result = "9";
          break;
        case 4:
          result = "8";
          break;
        case 5:
          result = "7";
          break;
        case 6:
          result = "6";
          break;
        case 7:
          result = "5";
          break;
        case 8:
          result = "4";
          break;
        case 9:
          result = "3";
          break;
        case 10:
          result = "2";
          break;
      }
      return result;
    },
    LeapYear(intYear) {
      if (intYear % 100 == 0) {
        if (intYear % 400 == 0) {
          return true;
        }
      } else {
        if (intYear % 4 == 0) {
          return true;
        }
      }
      return false;
    },
    // 验证
    verify(){
      if(this.memberInfo.real_name.replace(" ","") == ''){
        this.$toast('姓名不能为空哦')
        this.memberInfo.real_name = ''
        return
      }
      let label = ['本人','配偶','儿子','女儿','父亲','母亲','配偶父亲','配偶母亲']
      if(this.memberInfo.role == 9 && label.indexOf(this.memberInfo.role_label) != -1){
        this.$toast('请直接点选该角色')
        return
      }
      if( this.memberInfo.id_number ){
        if( !this.isCid(this.memberInfo.id_number) ){
          this.$toast('请输入正确的身份证号码')
          return
        }
      } 
      if( this.memberInfo.telephone ){
        if( !/^1\d{10}$/.test(this.memberInfo.telephone) ){
          this.$toast('请输入正确的手机号码')
          return
        }
      }
      // 如果有id 就编辑 无就添加
      if( this.memberId ){
        this.editMemberInfo()
      }else{
        this.addMemberInfo()
      }
    },
    // 添加成员
    addMemberInfo(){
      this.axios({
        method: 'POST',
        url: '/user-family',
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data: {
          real_name: this.memberInfo.real_name.replace(" ",""),
          role: this.memberInfo.role,
          role_label: this.memberInfo.role == 9 ? this.memberInfo.role_label: '',
          id_number: this.memberInfo.id_number,
          birthday: this.memberInfo.birthday,
          telephone: this.memberInfo.telephone,
          occupation: this.memberInfo.occupation,
          gender: this.memberInfo.gender,
          protection: this.protectionChoose.join(','),
          new_disease: this.diseaseChoose.join(',')
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.$toast('添加成功')
          setTimeout(()=>{
            this.$router.push(this.from)
          }, 1000)
        }else if(res.data.code == 40022){
          let msg = ''
          for(let i in res.data.message){
            if (msg == ''){
              msg = res.data.message[i][0]
              this.$toast(msg)
            }
          }
        }else{
          this.$toast(res.data.message)
        }
      })
    },
    // 编辑成员信息
    editMemberInfo(){
      this.axios({
        method: 'PATCH',
        url: `/user-family/${this.memberId}`,
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        },
        data: {
          real_name: this.memberInfo.real_name.replace(" ",""),
          role: this.memberInfo.role,
          role_label: this.memberInfo.role == 9 ? this.memberInfo.role_label: '',
          id_number: this.memberInfo.id_number,
          birthday: this.memberInfo.birthday,
          telephone: this.memberInfo.telephone,
          occupation: this.memberInfo.occupation,
          gender: this.memberInfo.gender,
          protection: this.protectionChoose.join(','),
          new_disease: this.diseaseChoose.join(',')
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.$toast('修改成功')
          setTimeout(()=>{
            this.$router.push(this.from)
          }, 1000)
        }else if(res.data.code == 40022){
          let msg = ''
          for(let i in res.data.message){
            if (msg == ''){
              msg = res.data.message[i][0]
              this.$toast(msg)
            }
          }
        }else{
          this.$toast(res.data.message)
        }
      })
    },
    // 有id时先获取原有信息
    getMemberInfo(id){
      this.axios({
        method: 'GET',
        url: `/user-family/${id}`,
        headers: {
          'Authorization': `Bearer ${this.Global.getCookie('token')}` 
        }
      }).then((res) => {
        if(res.data.code == 0){
          this.memberInfo = res.data.data
          // if(this.memberInfo.occupation){
          //   this.occupationInput = this.occupation;
          // }
          if(this.memberInfo.protection){
            this.protectionChoose = this.memberInfo.protection.split(',')
            for(var i in this.protectionChoose){
              this.$set(this.item2,this.protectionChoose[i],this.protectionChoose[i])
            }
          }
          if(this.memberInfo.new_disease){
            this.diseaseChoose = this.memberInfo.new_disease.split(',')
            for(var j in this.diseaseChoose){
              this.$set(this.items,this.diseaseChoose[j],this.diseaseChoose[j])
            }
          }
          if(this.memberInfo.gender){
            this.memberInfo.sexname = this.sexarr[this.memberInfo.gender-1]
          }else{
            this.memberInfo.gender = 1;
            this.memberInfo.sexname = '男';
          }
          console.log(this.memberInfo.sexname,this.memberInfo.sex)
          if(this.memberInfo.role != 9){
            this.memberInfo.role_label = ''
          }
        }
      })
    }
  },
  created(){
    this.from = this.$route.query.from
    if(this.$route.query.memberId){
      this.memberId = this.$route.query.memberId
      this.getMemberInfo(this.memberId)
    }
    this.Global.getShareConfig({
      title: '点击获取私人家庭保障方案',
      desc: '一对一咨询，分析风险，定制保障方案，让你买的放心，保的全面'
    },this)
  }
}
</script>

<style scoped>
.diseaseul>div{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f7f7f7;
  position: fixed;
  height: 2.5rem;
  width: 100%;
  background: white;
  }
.diseaseul ul{padding-top: 2.5rem;}
 .diseaseul{
    width: 100%;
    position: fixed;
    overflow: auto;
    bottom: 0;
    top: 0;
    background: white;}
.diseaseul li{    text-align: center;
    padding: 0.5rem;
    border: 1px solid #c7c7cc;
    border-radius: 1rem;
    margin: 0.5rem 0.5rem;
    color: #c7c7c7;}
.diseaseul .active{
  border: 1px solid rgba(255,161,39,1);
  background: rgba(255,161,39,1);
  color: white;
}
.wrapper{
  background: url("../assets/images/memberInfo/bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 1.4375rem 0.6875rem;
}
.container {
  background: #fff;
  border-radius: 0.875rem;
  box-shadow: 0.0625rem 0.28rem 2.28rem 0 rgba(81, 62, 43, 0.23);
  padding: 1.8rem 1rem;
}
input {
  border: none;
}
input::-webkit-input-placeholder {
  color: #cbcbcb;
}
.block {
  margin-bottom: 2rem;
}
.block .block-title {
  margin-bottom: 0.8rem;
}
.block .block-title span:first-of-type {
  font-size: 1rem;
  font-weight: 500;
  color: #4d4d4d;
  position: relative;
  padding-left: 0.625rem;
}
.block .block-title span:first-of-type::before {
  content: "";
  width: 0.1875rem;
  height: 0.8125rem;
  background: rgba(255,161,39,1);
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
}
.block .block-title .select {
  margin-left: 0.2rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: #b0b0b0;
}
.block .normal {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d7dae2;
  height: 3.125rem;
}
.block .normal label {
  position: relative;
  width: 5rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: #2a2a2a;
  flex-shrink: 0;
}
label.must::after {
  content: "*";
  color: #ff9024;
  font-size: 0.875rem;
  line-height: 1.28rem;
}
.block .normal input,
.block .normal select {
  flex: 1;
  font-size: 0.875rem;
  font-weight: 400;
  color: #2a2a2a;
}
.block .big p {
  padding: 1.375rem 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: #2a2a2a;
}
.relationship ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.relationship ul input {
  flex: 1;
  margin-left: 0.84rem;
  border-bottom: 1px solid #d7dae2;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 0.75rem;
}
.relationship ul li {
  border: 1px solid #c7c7cc;
  border-radius: 0.875rem;
  width: 4.3125rem;
  height: 1.75rem;
  line-height: 1.625rem;
  font-size: 0.75rem;
  font-weight: 400;
  color: #a0a0a0;
  text-align: center;
  margin-bottom: 0.75rem;
}
.relationship ul li.active {
  border-color: rgba(255,161,39,1);
  background: rgba(255,161,39,1);
  color: #fff;
}
.situation {
  border-bottom: 1px solid #d7dae2;
}
.situation .content {
  display: flex;
  flex-wrap: wrap;
}
.situation .content span {
  display: inline-block;
  position: relative;
  margin-bottom: 1.1875rem;
  padding: 0 0.85rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 1rem;
  background: rgba(255,161,39,1);
  color: #fff;
  font-size: 0.875rem;
  font-weight: 400;
  margin-right: 1rem;
}
.situation .content span img {
  width: 0.72rem;
  position: absolute;
  top: 0;
  right: 0;
}
.situation .content .add {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: rgba(255,161,39,1);
  margin-bottom: 1.1875rem;
  font-style: normal;
}
.situation .content .add img {
  width: 0.875rem;
  margin-right: 0.47rem;
}

.savebtn {
  width: 100%;
  height: 2.875rem;
  box-shadow: 0.0625rem 0.3125rem 0.5625rem 0 rgba(245, 130, 18, 0.27);
  border-radius: 1.4375rem;
  color: #fff;
  font-size: 1.25rem;
  line-height: 2.875rem;
  margin: 0 auto;
}
</style>